import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-profit-margin-report-preview',
  templateUrl: './profit-margin-report-preview.component.html',
  styleUrls: ['./profit-margin-report-preview.component.scss']
})
export class ProfitMarginReportPreviewComponent {
  @Input() data: any = null;

  columns = [
    { key: 'warehouseName', label: 'Código' },
    { key: 'productName', label: 'Producto' },
    { key: 'quantity', label: 'Cantidad', align: 'end' },
    { key: 'totalSalePrice', label: 'Ingreso', format: 'money' },
    { key: 'totalCost', label: 'Costo Ventas', format: 'money' },
    { key: 'grossMargin', label: 'Utilidad Bruta', format: 'money' },
    { key: 'grossMarginPercent', label: 'Margen %', format: 'percent' }
  ];

  formatValue(value: number, format?: string): string | null {
    if (value == null) return null;

    switch (format) {
      case 'percent':
        return `${(value).toFixed(4)} %`;
      case 'money':
        return value.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      default:
        return value.toString();
    }
  }


  getTotal(key: string): number {
    return this.data.reduce((sum, r) => sum + (r[key] || 0), 0);
  }
}
